<template>
    <div class="content">
        <div>
            <h5>Drivers 25 years of age and over</h5>
            <span>${{ parseInt( excess ) }}</span>
        </div>
        <div>
            <h5>Drivers under 25 years of age</h5>
            <span v-if="answerLabel(getStep('quote'),'vehicle_excess_under_25_note')">${{ parseInt( excess ) + 500 }}</span><p v-else>Cover Excluded</p>
        </div>
        <div>
            <h5>Inexperienced drivers</h5>
            <span>Additional $400</span>
            <p>An inexperienced driver is anyone over the age of 25 and has held a full Class 1 New Zealand driver licence for less than two years.</p>
        </div>
        <div>
            <h5>International drivers</h5>
            <span>Additional $400</span>
            <p>An international driver is any driver who does not hold a current driver licence from one of:</p>
            <ul>
            <li>Australia</li>
            <li>South Africa</li>
            <li>Ireland</li>
            <li>UK</li>
            <li>Japan</li>
            <li>Cook Islands</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

computed: {
  ...mapGetters({ answers: 'flattenedAnswers', answerLabel: 'getAnswerLabel', getStep: 'getStep'}),

    excess() {
      if (this.answers[this.getStep('quote')].vehicle_excess) {
        return this.answers[this.getStep('quote')].vehicle_excess
      }
      if (this.answers[this.getStep('quote')].vehicle_excess_third_party) {
        return this.answers[this.getStep('quote')].vehicle_excess_third_party;
      }
      return false;
    }
},

  methods: {
  },
  data: function () {
      return {
      }
  }
}
</script>

<style scoped lang="scss">

    .content {

        ul {
            list-style: disc outside;
            margin-left: 2em;
            margin-top: 1em;

            li {
                padding:0;
                margin:0;
                line-height:1.2rem;
            }
        }

        > div {
            padding-bottom:0.5rem;
            margin-bottom:0.5rem;
            border-bottom:1px solid $light-grey;

            &:last-child {
                border-bottom:none;
            }
        }
    }

</style>